module.exports = __webpack_public_path__ + "public/img/logo.17a98f6a.png";